import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ScheduleDashboard from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ScheduleDashboard />
);